// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14xjj","right":"styles_right__19Pl7"};